const DEFAULT_API_BASE_PATH = '/api';

type RuntimeConfig = {
  apiBasePath?: string;
};

const normalizeBasePath = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.replace(/\/+$/, '');
};

const getRuntimeApiBasePath = (): string => {
  if (typeof window === 'undefined' ) {
    return '';
  }

  const config = (window as Window & { __APP_CONFIG__?: RuntimeConfig }).__APP_CONFIG__;
  if (!config || typeof config.apiBasePath !== 'string') {
    return '';
  }

  return config.apiBasePath;
};

const isLocal =
    process.env.NODE_ENV === 'development' ||
    (typeof window !== 'undefined' &&
        window.location.hostname === 'localhost');

const runtimeBasePath = normalizeBasePath(getRuntimeApiBasePath());
const buildBasePath = normalizeBasePath(process.env.REACT_APP_API_BASE_PATH ?? '');

export const API_BASE_URL =
    isLocal
        ? 'http://localhost:8000/api'
        : runtimeBasePath || buildBasePath || DEFAULT_API_BASE_PATH;
